import { render, staticRenderFns } from "./CategoriesManager.vue?vue&type=template&id=790ea624&"
import script from "./CategoriesManager.vue?vue&type=script&lang=js&"
export * from "./CategoriesManager.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LoadingOverlay: require('/lasso/components/LoadingOverlay.vue').default,CategorySort: require('/lasso/components/questions/CategorySort.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790ea624')) {
      api.createRecord('790ea624', component.options)
    } else {
      api.reload('790ea624', component.options)
    }
    module.hot.accept("./CategoriesManager.vue?vue&type=template&id=790ea624&", function () {
      api.rerender('790ea624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/CategoriesManager.vue"
export default component.exports